import { pick } from 'lodash';
import { StyleSheet } from 'react-native';

const createStyles = (attributes: any) => {
  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'borderRadius',
        'opacity',
        'height',
        'width',
      ]),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: attributes.backgroundColor || '#000',
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      borderStyle:
        attributes.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      zIndex: attributes.zIndex,
      overflow: 'hidden',
    },
  });
};

export default createStyles;
